// extracted by mini-css-extract-plugin
export default {"container":"Newsletter_container__Cr+rI"};